import * as React from 'react'
import { withLayout, LayoutProps } from '../components/Layout'
import { Divider } from 'semantic-ui-react'
import Banner from '../components/Banner/Banner'
import Projects from '../components/Projects/Projects'
import Office from '../components/Office/Office'
import Clients from '../components/Clients/Clients'
import Contact from '../components/Contact/Contact'

const IndexPage = (props: LayoutProps) => (
  <div>
    <Banner />
    <Divider hidden />
    <Office />
    <Divider />
    <Projects />
    <Divider />
    <Clients />
    <Divider hidden />
    <Contact />
  </div>
)

export default withLayout(IndexPage)
